// extracted by mini-css-extract-plugin
export default {"inputWrapper":"TextInput_inputWrapper__7eqDI","label":"TextInput_label__2a9GP","input":"TextInput_input__-4vV7","errorMessage":"TextInput_errorMessage__QSR9C"};